import React, { useState, useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import './Assistant.css';
import 'react-resizable/css/styles.css';
import Tooltip from '@mui/material/Tooltip';
import { ChatProps } from '../services/chatApi';
import CircularProgress from '@mui/material/CircularProgress';
import JunkOutlineIcon from '../components/JunkOutlineIcon';

const Assistant: React.FC<ChatProps> = ({ inputValue, deleteChatHandler, submitHandler, messages, setInputHandler, isLoading }) => {
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const [isTraceVisible, setIsTraceVisible] = useState(() => {
        const saved = localStorage.getItem('traceVisible');
        return saved ? JSON.parse(saved) : false;
    });
    const handleTraceVisible = () => {
        setIsTraceVisible(!isTraceVisible);
    };
    const handleSubmitAndFocus = async (e: React.FormEvent<HTMLFormElement>) => {
        await submitHandler(e);
        setTimeout(function () {
            inputRef.current.focus();
        }, 100);
    };
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);
    useEffect(() => {
        localStorage.setItem('traceVisible', JSON.stringify(isTraceVisible));
    }, [isTraceVisible]);


    return (
        <div className="dashboard-container">
                <div style={{ width: '100%', height: "100%", display: 'flex', flexDirection: 'column' }}>
                    <div className="chat-header2">
                        <span>PwC Migration Assistant</span>
                    {isLoading ? '' : <div className="chat-controls2">
                        <button onClick={deleteChatHandler} className="delete-chat-button2">
                            <Tooltip title="Delete chat">
                                <JunkOutlineIcon width={12} height={12} />
                            </Tooltip>
                        </button>
                        {messages.some(message => message.fullResponse) ?
                            <input type="checkbox" id="showTrace" checked={isTraceVisible} onChange={handleTraceVisible} />
                            : ''}
                    </div>}
                    </div>
                    <div className="chat-messages2">
                    {messages.map(message => (
                        <div key={message.id} className={`message2 ${message.isUser ? 'user-message2' : 'assistant-message2'}`} >
                                <div className="message-content2">
                                    <ReactMarkdown>{message.text}</ReactMarkdown>
                                </div>
                            </div>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>
                    <form onSubmit={handleSubmitAndFocus} className="chat-input-container2">
                    <input
                        ref={inputRef}
                        type="text"
                        disabled={isLoading}
                        value={inputValue}
                        onChange={setInputHandler}
                        placeholder="Type your message..."
                        className="chat-input2"
                    />
                    {isLoading ? <CircularProgress size="30px" /> : <button type="submit" className="send-button2">
                        Send
                    </button>}
                </form>
                    {isTraceVisible && messages.some(message => message.fullResponse) ?
                        <div className="chat-messages2">
                            {messages.filter(message => message.fullResponse).map(message => (
                                <div className='message2 assistant-message2' >
                                    <div className="message-content2">
                                        <ReactMarkdown>{"```json\n" + message.fullResponse + "\n```"}</ReactMarkdown>
                                    </div>
                                </div>
                            ))}
                        </div> : ''}
                </div>
        </div>
    );
};

export default Assistant; 